import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { differenceBy } from "lodash";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import {fetchDetails, insertDetails, updateDetails} from "helpers/backend_helper"
//redux
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomCreatableSelect from "components/Common/CustomCreatableSelect"
import { changePreloader } from "../../store/actions";
import { showSuccessAlert, showFailureAlert, findChangesV2 } from "helpers/function_helper"
import "flatpickr/dist/themes/airbnb.css"
import Flatpickr from "react-flatpickr"
import * as dayjs from 'dayjs'

const Notifications = props => {
  const dispatch = useDispatch();

  const [inProgress, setInProgress] = useState(false);
  const [viewOldNotications, setViewOldNotications] = useState(false);

  const [allNotifications, setNotifications] = useState([]);

  useEffect(()=>{
    if(props.eventCode){
      getNotifications(props.eventCode)
    }
    
  },[props.eventCode])

  const getNotifications=async(eventCode)=>{
    setInProgress(true)
    let inputToSend = {
      "data": {
        "type": 'ALL_NOTIFICATIONS',
        "game": {
          "eventCode": eventCode,
        }
      }
    }
    const resp = await fetchDetails(inputToSend)
    if(resp && resp.status=='success'){
      if(resp.data){
        setNotifications(resp.data)
      }
    }
    setInProgress(false)
  }


  const validation = useFormik({
    enableReinitialize: false,
    initialValues: {
      eventCode: props.eventCode,
      title: '',
      notification: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().trim().required("Please enter the title."),
      notification: Yup.string().trim().required("Please enter the notification.")
    }),
    onSubmit: (values) => {
      //console.log('values:',values)
      saveDetails(values)
    }
  });

  const saveDetails = async(values)=>{
    setInProgress(true)
    dispatch(changePreloader(true))

    let inputToSend = {
      "data": {
        "type": 'NEW_NOTIFICATION',
        "notification":{
          eventCode: props.eventCode,
          title: values.title,
          notification: values.notification,//.replaceAll('\'','\'\'')
        }
      }
    }
    const resp = await insertDetails(inputToSend)
    //console.log('resp:',resp)
    if(resp && resp.status == 'success'){
      showSuccessAlert('Added Successfully!')
      props.onAdditionSuccess()
    }

    setInProgress(false)
    dispatch(changePreloader(false))
  }

  const closePopUp=()=>{
    props.onClosePopUp()
  }

  function updateIsEditFalseForAll() {
    var modifiedRows = [...allNotifications]
      modifiedRows = modifiedRows.map(eachRow => {
        return {
          ...eachRow,
          isEdit: false,
        }
    })
    setNotifications(modifiedRows)
  }

  function handleInputTextChange(id, key, value) {
    var modifiedRows = [...allNotifications]
      modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["id"] == id){
        //eachRow["productrate"] = value
        return {
          ...eachRow,
          [key]: value,
        }
      }
      else {
        return eachRow
      }
    })
    setNotifications(modifiedRows)
  }

  async function handleSave(editedRow){
    setInProgress(true)
    dispatch(changePreloader(true))
    if(editedRow && editedRow.title != '' && editedRow.notification != ''){
      //const changes = findChangesV2(props.matchDetailsForEdit, values ,[])
      //console.log('changes?',changes)
      let inputToSend = {
        "data": {
          "type": 'UPDATE_NOTIFICATION',
          "notification":{
            ...editedRow,
            notification: editedRow.notification, //.replaceAll('\'\'','\'').replaceAll('\'','\'\''),
            eventCode: props.eventCode,
          }
        }
      }
      const resp = await updateDetails(inputToSend)
      //console.log('resp:',resp)
      if(resp && resp.status == 'success'){
        showSuccessAlert('Updated Successfully!')
        updateIsEditFalseForAll()
      }
    }
    setInProgress(false)
    dispatch(changePreloader(false))
  }

  async function handleDeleteRule(editedRow){
    
    setInProgress(true)
    dispatch(changePreloader(true))
    if(editedRow && editedRow.title != '' && editedRow.notification != ''){
      //const changes = findChangesV2(props.matchDetailsForEdit, values ,[])
      //console.log('changes?',changes)
      let inputToSend = {
        "data": {
          "type": 'DELETE_NOTIFICATION',
          "notification":{
            ...editedRow,
            eventCode: props.eventCode,
          }
        }
      }
      const resp = await updateDetails(inputToSend)
      //console.log('resp:',resp)
      if(resp && resp.status == 'success'){
        showSuccessAlert('Deleted Successfully!')
        props.onAdditionSuccess()
      }
    }
    setInProgress(false)
    dispatch(changePreloader(false))
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid={true}>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="text-center mb-2">
                    <Col>
                      <span className="page-heading">Notifications</span>
                    </Col>
                  </Row>
                
                  {viewOldNotications && allNotifications && allNotifications.length > 0 && allNotifications.map((each,idx)=> (
                    <Row className="mt-3 align-items-center" key={'rl'+idx}>
                      <Col xs={12} md={12}>
                        <Row>
                          <Col xs={12} md={3} className="text-sm-start text-md-end">
                            <Input
                              name="title"
                              type="text"
                              maxLength={100}
                              disabled={!each.isEdit}
                              placeholder="Notification Heading"
                              onChange={e=>{
                                handleInputTextChange(each.id,'title',e.target.value)
                              }} 
                              value={allNotifications.filter(x=>x["id"]==each.id)[0].title}
                            />
                          </Col>
                          <Col xs={12} md={8} className="">
                            <Input
                                name="notification"
                                type="textarea"
                                rows="2"
                                disabled={!each.isEdit}
                                maxLength={1000}
                                placeholder="Notification message"
                                onChange={e=>{
                                  handleInputTextChange(each.id,'notification',e.target.value)
                                }} 
                                value={allNotifications.filter(x=>x["id"]==each.id)[0].notification}
                              />
                          </Col>
                          <Col xs={12} md={1} className="">
                            {!each.isEdit && 
                            <Button
                              color="secondary"
                              className="mb-2"
                              onClick={(e) => {
                                handleInputTextChange(each.id,'isEdit',true)
                              }}
                              disabled={inProgress}
                              >
                                Edit
                              {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                            </Button>
                            }
                            {each.isEdit && 
                            <Button
                              color="primary"
                              className="me-2 mb-2"
                              onClick={(e) => {
                                handleSave(each)
                              }}
                              disabled={inProgress}
                              >
                                Save
                              {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                            </Button>
                            }
                            {each.isEdit && 
                            <Button
                              color="danger"
                              className="me-2"
                              onClick={(e) => {
                                handleDeleteRule(each)
                              }}
                              disabled={inProgress}
                              >
                                Delete Notification
                              {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                            </Button>
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ))
                  }
                  
                  
                  <Row className="mt-3 align-items-center">
                    <Col xs={12} md={12}>
                      <Row>
                        <Col xs={12} md={3} className="text-sm-start text-md-end">
                          <Input
                            name="title"
                            type="text"
                            maxLength={50}
                            placeholder="Title"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title || ""}
                            invalid={
                              validation.touched.title && validation.errors.title ? true : false
                            }
                          />
                          {validation.touched.title && validation.errors.title ? (
                            <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                          ) : null}
                        </Col>
                        <Col xs={12} md={8} className="">
                          <Input
                              name="notification"
                              type="textarea"
                              rows="2"
                              maxLength={1000}
                              placeholder="Notification message"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.notification || ""}
                              invalid={
                                validation.touched.notification && validation.errors.notification ? true : false
                              }
                            />
                          {validation.touched.notification && validation.errors.notification ? (
                            <FormFeedback type="invalid">{validation.errors.notification}</FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  
                  <Row className="mt-4 justify-content-center">
                    <Col className="text-center">
                      <Button
                        color="primary"
                        className="w-lg me-2"
                        onClick={(e) => {
                          setViewOldNotications(!viewOldNotications)
                        }}
                        disabled={inProgress}
                        >
                           {viewOldNotications ? 'Hide Old Notifications' : 'View Old Notifications'}
                          {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                      </Button>
                      <Button
                        color="secondary"
                        className="w-lg me-2"
                        onClick={(e) => {
                          closePopUp()
                        }}
                        disabled={inProgress}
                        >
                           Close
                          {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                      </Button>
                      <Button
                        color="cust-1"
                        className="w-lg "
                        onClick={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        disabled={inProgress}
                        >
                          Save
                          {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                      </Button>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </Container>
      </div>
    </React.Fragment>
  );
};

Notifications.propTypes = {
};

export default Notifications;
